<template>
  <section class="app-section"
    v-loading.fullscreen="isRequesting"
    element-loading-text="サーバーに問い合わせています">

    <header class="app-header flex justify-between items-center">
      <h2 class="app-h2">アップロード画像</h2>
      <router-link to="media/upload">
        <el-button>追加</el-button>
      </router-link>
    </header>

    <template v-if="isInitialized">
      <ul class="padding image-list flex wrap justify-start items-stretch">
        <template v-for="(item, index) in media">
          <li :class="['image-item', item.alt_text === '' ? 'warning' : '']" :key="item.id">
            <div class="image-wrapper flex justify-center items-center"
              @click="showPreview(item)">
              <img class="image" :src="item.source_url" />
            </div>
            <div class="image-content">
              <el-form :model="item">
                <p class="image-size">{{item.title.rendered}}</p>
                <p class="image-size">{{item.media_details.width}} x {{item.media_details.height}}</p>
                <el-input type="textarea" :autosize="true" v-model="item.alt_text" auto-complete="off" placeholder="SEO対策のために代替テキストを入力してください"></el-input>
              </el-form>
              <div class="image-controller flex justify-between items-center">
                <el-button type=text class=icon-button>
                  <a :href="item.source_url" target="_blank">
                    <i class="fa fa-external-link"></i>
                    <span>確認</span>
                  </a>
                </el-button>
                <el-button type=text class="icon-button danger" @click="confirmBeforeDelete(item)">
                  <i class="fa fa-trash-o"></i>
                  <span>削除</span>
                </el-button>
                <el-button type=text class=icon-button @click="updateImage(item)">
                  <i class="fa fa-refresh"></i>
                  <span>更新</span>
                </el-button>
              </div>
            </div>
          </li>
        </template>
      </ul>
    </template>

    <el-dialog width="75%" title="Preview" :visible.sync="dialogImageVisible">
      <div class="preview-image-wrapper" v-if="previewImage" @click="hidePreview">
        <img class="preview-image" :src="previewImage.source_url">
      </div>
    </el-dialog>

    <el-dialog width="50%" title="確認" :visible.sync="confirmDialogVisible">
      <span style="display:block;margin-bottom:1em">画像を削除しますか？</span>
      <div class="preview-image-wrapper" v-if="deletingImage">
        <img class="preview-image" :src="deletingImage.source_url">
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmDialogVisible = false">いいえ</el-button>
        <el-button type="primary" @click="deleteImage">はい</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="error.title" :visible.sync="dialogErrorVisible">
      <span>{{ error.message }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogErrorVisible = false">OK</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import RouteBase from '@/components/mixins/RouteBase'

export default {
  name: 'media',
  mixins: [RouteBase],
  data () {
    return {
      previewImage: null,
      dialogImageVisible: false,
      confirmDialogVisible: false,
      deletingImage: null
    }
  },
  methods: {
    showPreview: function (image) {
      this.previewImage = image
      this.dialogImageVisible = true
    },
    hidePreview: function (image) {
      this.previewImage = null
      this.dialogImageVisible = false
    },
    updateImage: async function (image) {
      this.isRequesting = true
      let response = await this.$store.dispatch('wordpress/media/update', image)
      this.isRequesting = false
      if (response.id === image.id) {
        this.$notify({
          title: '更新完了',
          message: 'サーバーデータを更新しました',
          type: 'success',
          duration: 1500
        })
      } else {
        this.$notify({
          title: '更新失敗',
          message: 'サーバーデータを更新できませんでした',
          type: 'error',
          duration: 1500
        })
      }
    },
    confirmBeforeDelete: function (image) {
      this.deletingImage = image
      this.confirmDialogVisible = true
    },
    deleteImage: async function () {
      this.isRequesting = true
      let response = await this.$store.dispatch('wordpress/media/delete', this.deletingImage)
      this.isRequesting = false
      if (response.id === this.deletingImage.id) {
        this.$notify({
          title: '削除完了',
          message: 'サーバーデータを更新しました',
          type: 'success',
          duration: 1500
        })
      } else {
        this.$notify({
          title: '削除失敗',
          message: 'サーバーデータを更新できませんでした',
          type: 'error',
          duration: 1500
        })
      }
      this.deletingImage = null
      this.confirmDialogVisible = false
    }
  },
  created: async function () {
    if (process.env.NODE_ENV !== 'production') console.log('On Media created...')

    this.isRequesting = true
    try { await this.requestMedia() } catch (error) { return false }
    this.isRequesting = false
    this.isInitialized = true
  }
}
</script>

<style lang="scss" scoped>
.image {
  display: block;
  border-radius: 8px 8px 0 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  &-wrapper {
    margin-right: 1em;
    width: 100%;
    max-width: 280px;
    height: 130px;
    position: relative;
    overflow: hidden;
    text-align: center;
    cursor: pointer;
  }
  &-content {
    padding: 1em 1em .5em;
  }
  &-item {
    margin: .5em;
    border: 1px solid #bfcbd9;
    border-radius: 8px;
    width: 100%;
    max-width: 280px;
    &.warning {
      border-color: #ff4949;
    }
  }
  &-size {
    margin: .25em;
  }
  &-controller {
    margin-top: .5em;
  }
}
.el-button .fa {
  margin-right: .3em;
}
.el-button {
  &.danger {
    color: #ff4949;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
}
.preview {
  &-image {
    display: block;
    margin: 0 auto;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/routes/Media.vue